import { OpenAPIClientAxios } from 'openapi-client-axios';
import Schema from '@hekla-catalogue/openapi-specification/dist/schema.json';

const server = (process.env.RELEASE === 'production') ? 'Production' : 'Staging';

const api = new OpenAPIClientAxios({
  definition: Schema,
  withServer: server,
  validate: true,
  axiosConfigDefaults: {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
});

api.init();

export default api;
